import { Injectable } from "@angular/core"
import { Actions, createEffect, ofType } from "@ngrx/effects"
import { of } from "rxjs"
import { concatMap, map, catchError, switchMap } from "rxjs/operators"

import { AuthActions } from "./action-types"
import { AuthService } from "../auth.service"

import * as Utils from "../lib/utils"
import { environment } from "src/environments/environment"
import { Router } from "@angular/router"

@Injectable()
export class AuthEffects {
	login$ = createEffect(() =>
		this.actions$.pipe(
			ofType(AuthActions.loginRequest),
			concatMap(action =>
				this.authService.login(action.request).pipe(
					map(response => {
						Utils.saveToLocalStorage(response)
						setTimeout(() => {
							window.location.replace(environment.redirectSSOUrl)
							// window.location.replace('/home');
						}, 1000)
						return AuthActions.loginSuccess()
					}),
					catchError(error => of(AuthActions.loginError({ error })))
				)
			)
		)
	)

	loginSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(AuthActions.loginSuccess),
			switchMap(() => [AuthActions.startRefreshInterval()])
		)
	)

	loadUserInfo$ = createEffect(() =>
		this.actions$.pipe(
			ofType(AuthActions.loadUserInfo),
			switchMap(() => this.authService.getUserInfo()),
			map(user => AuthActions.saveUser({ user }))
		)
	)

	loginError$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(AuthActions.loginError),
				map(action => of(console.log(action.error)))
			),
		{ dispatch: false }
	)

	logout$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(AuthActions.logout),
				map(() => {
					Utils.clear()
					return 0
				})
			),
		{ dispatch: false }
	)

	constructor(
		private actions$: Actions,
		private authService: AuthService,
		private router: Router
	) {}
}
